export enum UserType {
  RECRUITER = "recruiter",
  MANAGER = "manager",
  CANDIDATE = "candidate",
}

export enum StatusType {
  APPLIED = "applied",
  WITHDRAWN = "withdrawn",
  PENDING_RECRUITER = "pending_recruiter",
  UNDER_REVIEW = "under_review",
  INTERVIEWING_RECRUITER = "interviewing_recruiter",
  SHORTLISTED_RECRUITER = "shortlisted_recruiter",
  REJECTED_RECRUITER = "rejected_recruiter",
  PENDING_MANAGER = "pending_manager",
  INTERVIEWING_MANAGER = "interviewing_manager",
  SHORTLISTED_MANAGER = "shortlisted_manager",
  REJECTED_MANAGER = "rejected_manager",
  HIRED = "hired"
}

export enum Subscription {
  FREE = "free",
  STANDERD = "standerd",
  ENTERPRISE = "enterprise",
  SPECIAL = "SPECIAL",
  TALENT_POOL = "talent_pool",
}

export enum MeetingType {
  ONLINE = "Online (via Microsoft teams)",
  GOOGLE_MEET = "Online (via Google Meet)",
  PHONE = "Phone",
  INPERSON = "In Person",
}

export interface Data {
  message: string;
}
export interface ErrorType {
  message: string;
  name: string;
  stack: string;
  code: string;
  status: number;
  response: {
    data: {
      message: string;
    };
    status: number;
    statusText: string;
  };
}

export const TOKEN_KEY = "ACCESS_TOKEN";

export enum ROUTES {
  LANDING = "/",
  FOR_RECRUITERS = "/for-recruiters",
  FOR_JOB_SEEKERS = "/for-job-seekers",
  JOBS = "/browse-jobs",
  FINISH_SIGNUP = "/finishSignup",
  SIGN_IN = "/signin",
  AVAILABILITY = "/availability",
  TERMS = "/terms",
  POLICY = "/policy",
  CALENDAR = "/calendar",
  DASHBOARD = "/dashboard",
  SUBSCRIBE = "/payment",
  ABOUT = "/about",
  CANDIDATE_PROFILE = "/candidate/profile",
  CANDIDATE_DASHBOARD = "/candidate/dashboard",
  CANDIDATE_POOL = "/candidates",
  INVITATIONS = "/invitations",
  REPORTS = "/reports",
  SUBSCRIBE_EMAIL = "/subscribe-email",
  PAYMENT_HISTORY = "/billing",
}

export const AuthIgnoredPaths = [
  ROUTES.FINISH_SIGNUP,
  ROUTES.ABOUT,  // Add About page
  ROUTES.TERMS,  // Add Terms page
  ROUTES.POLICY, // Add Privacy Policy page
  ROUTES.LANDING,
  "/job-board",  // Public job board
  ROUTES.FOR_RECRUITERS,
  ROUTES.FOR_JOB_SEEKERS,
];
